/* eslint-disable no-unused-vars */
import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LayoutSplashScreen, Layout } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";
import { DashboardPage } from "./pages/DashboardPage";
import { DemoOffPage } from "./pages/DemoOffPage";
import Transaction from "./pages/Transaction/Transaction";
import AddTransaction from "./pages/Transaction/AddTransaction";
import Newsletter from "./pages/Newsletter/Newsletter";
import WalletRouter from "./pages/Wallet/WalletRouter";
import { TestingEnvironment } from "./pages/TestingEnvironment/TestingEnvironment";
import { DatabaseManagement } from "./pages/TestingEnvironment/DatabaseManagement";
import { useDispatch } from "react-redux";
import * as actions from "../store/actions/index";
import { WithdrawEarings } from "./pages/WithdrawEarings/WithdrawEarings";
import RevenueSettingsRouter from "./pages/RevenueSettings/RevenueSettingsRouter";
// const GoogleMaterialPage = lazy(
//   () => import("./modules/GoogleMaterialExamples/GoogleMaterialPage")
// );
// const ReactBootstrapPage = lazy(
//   () => import("./modules/ReactBootstrapExamples/ReactBootstrapPage")
// );
// const ECommercePage = lazy(
//   () => import("./modules/ECommerce/pages/eCommercePage")
// );
const DashboardRoutes = lazy(() => import("./pages/Dashboard/DashboardRouter"));
const UserManagement = lazy(() =>
  import("./pages/UserManagement/UserManagementRouter")
);
const Campaign = lazy(() => import("./pages/Campaign/CampaignRouter"));
const APIManagement = lazy(() =>
  import("./pages/APIManagement/APIManagementRouter")
);
const ContentPages = lazy(() =>
  import("./pages/ContentPages/ContentPagesRouter")
);
const Settings = lazy(() => import("./pages/Settings/SettingsRouter"));
const RevenueSettings = lazy(() =>
  import("./pages/RevenueSettings/RevenueSettingsRouter")
);
const Miscellaneous = lazy(() =>
  import("./pages/Miscellaneous/MiscellaneousRouter")
);
const SpamSetting = lazy(() => import("./pages/SpamSetting/SpamSettingRouter"));
const ManageOptions = lazy(() =>
  import("./pages/ManageOptions/ManageOptionsRouter")
);
const Inbox = lazy(() => import("./pages/Inbox/InboxRouter"));
const Activities = lazy(() => import("./pages/Activities/ActivitiesRouter"));
const ContactList = lazy(() => import("./pages/ContactList/ContactListRouter"));

const NotificationPages = lazy(() =>
  import("./pages/Notification/NotificationRouter")
);

const SecondaryMarket = lazy(() =>
  import("./pages/SecondaryMarket/SecondaryMarketRouter")
);

const Support = lazy(() => import("./pages/Support/SupportRouter"));
const AiAssistantPromptsRouter = lazy(() =>
  import("./pages/AiAssistantPrompts/AiAssistantPromptsRouter")
);

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="*" element={<Navigate to="/dashboard" />} />

          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="dashboard/*" element={<DashboardRoutes />} />
          <Route path="builder" element={<BuilderPage />} />
          <Route path="my-page" element={<MyPage />} />
          <Route path="user-management/*" element={<UserManagement />} />
          <Route path="campaign/*" element={<Campaign />} />
          <Route path="api-management/*" element={<APIManagement />} />
          <Route path="transaction" element={<Transaction />} />
          <Route
            path="transaction/add-transaction"
            element={<AddTransaction />}
          />
          <Route path="wallet/*" element={<WalletRouter />} />
          <Route path="Newsletter" element={<Newsletter />} />
          <Route path="content-page/*" element={<ContentPages />} />
          <Route path="settings/*" element={<Settings />} />
          <Route path="revenue-settings/*" element={<RevenueSettings />} />
          <Route path="/withdraw-earnings" element={<WithdrawEarings />} />
          <Route path="miscellaneous/*" element={<Miscellaneous />} />
          <Route path="spam-settings/*" element={<SpamSetting />} />
          <Route path="manage-options/*" element={<ManageOptions />} />
          <Route path="inbox/*" element={<Inbox />} />
          <Route path="activities/*" element={<Activities />} />
          <Route path="maintenance-mode" element={<TestingEnvironment />} />
          <Route path="support/*" element={<Support />} />
          <Route
            path="ai-assistant-prompts/*"
            element={<AiAssistantPromptsRouter />}
          />

          {/* <Route
            path="database-management/*"
            element={<DatabaseManagement />}
          /> */}
          {/* <Route path="google-material/*" element={<GoogleMaterialPage />} />
          <Route path="react-bootstrap/*" element={<ReactBootstrapPage />} />
          <Route path="e-commerce/*" element={<ECommercePage />} /> */}
          <Route path="contact-list/*" element={<ContactList />} />
          <Route
            path="web-notifications-templates/*"
            element={<NotificationPages />}
          />
          <Route path="secondary-market/*" element={<SecondaryMarket />} />

          <Route path="demo-off" element={<DemoOffPage />} />
          <Route path="*" element={<Navigate to="/error/error-v1" replace />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
